import { Button, IconMoon, IconSun } from "@dream/ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useTheme } from "../theme/theme.tsx";

/**
 * Alterna claro/escuro.
 *
 * Ícone à esquerda, rótulo à direita. Compacto (sidebar recolhida) vira só o
 * ícone, com o nome do tema no aria-label e no tooltip.
 */

export function ThemeToggle({
  compact = false,
  hintSide = "bottom",
}: {
  compact?: boolean;
  hintSide?: "bottom" | "right";
}) {
  const { theme, toggleTheme } = useTheme();
  const goingDark = theme === "light";
  const label = goingDark ? "Tema escuro" : "Tema claro";

  const control = (
    <Button
      variant="ghost"
      size={compact ? "icon" : "sm"}
      aria-label={label}
      aria-pressed={!goingDark}
      onClick={toggleTheme}
      className={compact ? undefined : "w-full justify-start gap-2.5 font-medium"}
    >
      <span key={theme} className="dream-enter inline-flex">
        {goingDark ? <IconMoon className="size-4" /> : <IconSun className="size-4" />}
      </span>
      {!compact && label}
    </Button>
  );

  if (!compact) return control;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{control}</TooltipTrigger>
      <TooltipContent side={hintSide}>{label}</TooltipContent>
    </Tooltip>
  );
}
